import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { panelToggleStyle, type PanelHostPlacement, type PanelSide } from './side-panel-placement';

interface FloatingPanelToggleProps {
  side: PanelSide;
  placement: PanelHostPlacement | null;
  label: string;
  controls: string;
  icon: ReactNode;
  onClick: () => void;
}

/** Folded-panel expand button for narrow hosts, rendered outside clipping ancestors. */
export function FloatingPanelToggle({ side, placement, label, controls, icon, onClick }: FloatingPanelToggleProps) {
  if (typeof document === 'undefined') return null;
  const target = placement?.layer ?? document.body;
  return createPortal(<Button type="button" size="icon" variant="outline" data-panel-toggle={side}
    className={cn(placement?.layer ? 'absolute' : 'fixed', 'z-40 size-11 min-h-11 min-w-11 rounded-full bg-background shadow-md print:hidden')}
    style={panelToggleStyle(side, placement)} aria-label={label} title={label} aria-expanded={false} aria-controls={controls} onClick={onClick}>
    {icon}
  </Button>, target);
}
